export enum DeliveryEvent {
  OCCURRENCE = 1,
  NO_OCCURRENCE = 2,
  RETURNED = 3,
  OCCURRENCE_AND_RETURNED = 4,
}
